export default __webpack_public_path__ + "static/media/AperahamLincoln.3436265e.jpg";